import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CommunityIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.4828 17H3.05976C1.37077 17 0 15.6292 0 13.9402V7.05375C0 6.05831 0.489561 5.11999 1.3055 4.54884L7.01704 0.550756C8.06959 -0.183585 9.48116 -0.183585 10.5256 0.550756L16.2371 4.54884C17.053 5.11999 17.5426 6.05831 17.5426 7.05375V13.9402C17.5426 15.6292 16.1718 17 14.4828 17ZM8.7713 1.21982C8.40413 1.21982 8.03696 1.33405 7.71874 1.55436L2.0072 5.55244C1.51764 5.89513 1.2239 6.45812 1.2239 7.05375V13.9402C1.2239 14.952 2.048 15.7761 3.05976 15.7761H14.4828C15.4946 15.7761 16.3187 14.952 16.3187 13.9402V7.05375C16.3187 6.45812 16.025 5.89513 15.5354 5.55244L9.82385 1.55436C9.50564 1.33405 9.13847 1.22798 8.7713 1.22798V1.21982Z"
        fill="currentColor"
      />
      <path
        d="M12.0352 16.9999H5.50776C5.17323 16.9999 4.89581 16.7225 4.89581 16.388V12.3083C4.89581 10.1706 6.63375 8.43262 8.7715 8.43262C10.9093 8.43262 12.6472 10.1706 12.6472 12.3083V16.388C12.6472 16.7225 12.3698 16.9999 12.0352 16.9999ZM6.11972 15.776H11.4233V12.3083C11.4233 10.8478 10.232 9.65652 8.7715 9.65652C7.31098 9.65652 6.11972 10.8478 6.11972 12.3083V15.776Z"
        fill="currentColor"
      />
    </svg>
  )
})

CommunityIcon.displayName = 'CommunityIcon'
